export const TimeDifferenceadmin = ({ dateTimeString }) => {
    const formatDateTime = (dateTime) => {
        const date = new Date(dateTime);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    };

    const formattedDate = formatDateTime(dateTimeString);

    return <div className="text-gray-600 font-normal">{formattedDate}</div>;
};
